<template>
  <md-card class="card-content">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">
          {{ $t("common.overview") }}
        </h4>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <!-- STUDENT INFORMATION -->
        <div
          v-if="!!studentInfo"
          class="md-layout-item md-size-50 md-medium-size-100 ml-[-15px]"
        >
          <information-area
            :title="$t('score_report.student.area_student_information')"
          >
            <template #content>
              <student-information :studentInfo="studentInfo">
                <template #extra-info>
                  <div v-html="renderStudentStatus(studentInfo)"></div>
                </template>
              </student-information>
            </template>
          </information-area>
        </div>
        <!-- STUDENT INFORMATION -->

        <!-- STUDENT RESULTS -->
        <div
          v-if="!!gpaSum"
          class="md-layout-item md-size-50 md-medium-size-100 mt-6 md-layout px-0"
        >
          <div
            class="md-layout-item md-size-25 md-xsmall-size-50 mb-3 md:mb-0 md:pl-0"
          >
            <result-box
              iconHTML="<i class='fas fa-user-graduate'></i>"
              :resultTxt="gpaSum.total_cpa"
              :title="$t('score_report.student.gpa')"
              :class="['result-box-color']"
            ></result-box>
          </div>
          <div
            class="md-layout-item md-size-25 md-xsmall-size-50 mb-3 md:mb-0 md:pl-0"
          >
            <result-box
              iconHTML="<i class='fas fa-book-open'></i>"
              :resultTxt="gpaSum.total_cpa_bonus_point"
              :title="$t('score_report.student.gpa_w_bonus_point')"
              :class="['result-box-color']"
            ></result-box>
          </div>
          <div
            class="md-layout-item md-size-25 md-xsmall-size-50 mb-3 md:mb-0 md:pl-0"
          >
            <result-box
              iconHTML="<i class='fas fa-book-reader'></i>"
              :resultTxt="gpaSum.total_earned_credits"
              :title="$t('score_report.student.total_earned_credit')"
              :class="['result-box-color']"
            ></result-box>
          </div>
          <div
            class="md-layout-item md-size-25 md-xsmall-size-50 mb-3 md:mb-0 md:pl-0"
          >
            <result-box
              iconHTML="<i class='fas fa-trophy'></i>"
              :resultTxt="gpaSum.current_rank"
              :title="$t('score_report.student.current_rank')"
              :class="['result-box-color']"
            ></result-box>
          </div>
        </div>
        <!-- STUDENT RESULTS -->

        <!-- GRADE CHART -->
        <div
          class="md-layout-item md-size-50 md-medium-size-100 ml-[-15px] mt-6"
        >
          <information-area
            :title="$t('score_report.student.area_grade_letter')"
          >
            <template #content
              ><grade-chart :grade-letter="gradeLetter"></grade-chart
            ></template>
          </information-area>
        </div>
        <!-- GRADE CHART -->

        <div
          v-if="!!creditsSum"
          class="md-layout-item md-size-50 md-medium-size-100 ml-[-15px] mt-6"
        >
          <information-area
            :title="
              $t('score_report.student.area_credits_summary') + programName
            "
          >
            <template #content>
              <div class="md-card">
                <md-table :value="creditsSum" md-fixed-header>
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item }"
                    :class="getClassRow(item)"
                  >
                    <md-table-cell
                      :md-label="
                        $t(
                          'score_report.student.credits_sum_table_col_grd_category'
                        )
                      "
                      >{{ item.name }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="
                        $t(
                          'score_report.student.credits_sum_table_col_grd_required'
                        )
                      "
                      >{{ item.needed }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="
                        $t(
                          'score_report.student.credits_sum_table_col_grd_earned'
                        )
                      "
                      >{{ item.earned }}</md-table-cell
                    >
                    <md-table-cell
                      :md-label="
                        $t(
                          'score_report.student.credits_sum_table_col_grd_remaining'
                        )
                      "
                      >{{ item.missing }}</md-table-cell
                    >
                  </md-table-row>
                </md-table>
              </div>
            </template>
          </information-area>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import {
  InformationArea,
  ResultBox,
  StudentInformation
} from "../../Components";
import { STUDENT_TABLE } from "../../utils";
import GradeChart from "./GradeChart.vue";

export default {
  components: { InformationArea, ResultBox, GradeChart, StudentInformation },
  inject: ["reportParams", "reportData"],
  computed: {
    studentInfo() {
      return this.reportParams.selectedStudent;
    },
    programName() {
      return this.reportParams.selectedProgram?.name;
    },
    gpaSum() {
      return this.reportData.gpaSum;
    },
    gradeLetter() {
      return this.reportData.gradeLetter;
    },
    courseGrades() {
      return this.reportData.courseGrades;
    },
    creditsSum() {
      return this.reportData.creditsSum;
    }
  },
  methods: {
    getClassRow(item) {
      if (item.isSumRow) return "sum-row font-semibold";

      return "";
    },
    renderStudentStatus(studentInfo) {
      return STUDENT_TABLE.generateStatusColHTML(studentInfo.study_status);
    }
  }
};
</script>

<style lang="scss" scoped>
.student-results {
  & > * + * {
    @apply ml-6;
  }
}
.result-box-color {
  width: 156px;
  color: #2d82b5;
}

.sum-row,
.sum-row td,
.sum-row td div {
  position: sticky;
  bottom: 0;
  z-index: 4;
}
</style>
